import { APP_HEADER_HEIGHT_VAR, HeaderContent, HEADER_TITLE_CLASS } from '../../../components/shell/app-header';

export default function BilanPositionnement6eApp() {
  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Bilan de positionnement 6e</h1>
          <p className="m-0 mt-0.5 text-[13px] leading-snug text-[color:var(--naia-text-secondary)]">
            Brouillon à valider — données fictives, rien n'est enregistré.
          </p>
        </div>
      </HeaderContent>
      <iframe
        src="/mini-apps/francais-college/bilan_positionnement_6e.html"
        title="Bilan de positionnement 6e"
        className="w-full border-0"
        style={{ height: `calc(100dvh - var(${APP_HEADER_HEIGHT_VAR}, 0px))` }}
        sandbox="allow-scripts allow-downloads"
      />
    </>
  );
}
